export default __webpack_public_path__ + "static/media/Path -5@2x.50138f57.png";